
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"レイヤー 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.7 58.29a3.5 3.5 0 01-2.54-1.09L1 35.1a3.53 3.53 0 015.1-4.88l18.34 19.17L57.7 7.06a3.52 3.52 0 115.54 4.36L27.48 56.94a3.51 3.51 0 01-2.6 1.35z"}})])
          )
        }
      }
    